'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import UIMedia from 'UIComponents/layout/UIMedia';
import UIMediaBody from 'UIComponents/layout/UIMediaBody';
import UIMediaLeft from 'UIComponents/layout/UIMediaLeft';
import UILink from 'UIComponents/link/UILink';
import Loadable from 'UIComponents/decorators/Loadable';
const UISimpleAvatar = Loadable({
  loader: () => import(
  /* webpackChunkName: "bundles/avatars" */
  'ui-addon-avatars').then(mod => mod.UIAvatar)
});
const socialMediaNamesMap = {
  twitter: 'Twitter',
  linkedin: 'LinkedIn'
};
const BASE_CLASS_NAME = 'professor-row';

const SocialLink = ({
  type,
  url
}) => {
  return url ? /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(UILink, {
      external: true,
      href: url,
      children: socialMediaNamesMap[type]
    })
  }) : null;
};

const ProfessorRow = ({
  name,
  description,
  image,
  twitterUrl,
  linkedinUrl
}) => /*#__PURE__*/_jsxs(UIMedia, {
  className: BASE_CLASS_NAME,
  children: [/*#__PURE__*/_jsx(UIMediaLeft, {
    children: /*#__PURE__*/_jsx(UISimpleAvatar, {
      alt: `Professor ${name}'s picture`,
      className: `${BASE_CLASS_NAME}__picture`,
      shape: "circle",
      size: "lg",
      src: image
    })
  }), /*#__PURE__*/_jsxs(UIMediaBody, {
    className: `${BASE_CLASS_NAME}__name-header`,
    children: [/*#__PURE__*/_jsx("h5", {
      children: name
    }), /*#__PURE__*/_jsx("p", {
      children: description
    }), /*#__PURE__*/_jsx(SocialLink, {
      type: "twitter",
      url: twitterUrl
    }), /*#__PURE__*/_jsx(SocialLink, {
      type: "linkedin",
      url: linkedinUrl
    })]
  })]
});

ProfessorRow.propTypes = {
  description: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  linkedinUrl: PropTypes.string,
  name: PropTypes.string.isRequired,
  twitterUrl: PropTypes.string
};
export default ProfessorRow;